import Vue from 'vue';

import '@cnamts/vue-dot/dist/vue-dot.css';

import 'dayjs/locale/fr';

import InputFacade from 'vue-input-facade';
import VueDot from '@cnamts/vue-dot';

Vue.use(InputFacade);
Vue.use(VueDot);
